import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ViewChild,
  NgZone,
  ElementRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { ICAreaService } from "../../../services/icarea.service";
import { ICUserService } from "../../../services/icuser.service";
import { ICUserApi } from "../../../models/apis/icuser.api";
import { ICAreaApi } from "../../../models/apis/icarea.api";
import { ICAreaFilter } from "../../../models/filters/icarea.filter";
import { ICAreaRelation } from "../../../models/entities/icarearelation";
import * as _ from "underscore";
import { Translation } from "../../../models/entities/translation";
import { Subscription } from "rxjs";
import { ICMetaDescriptionApi } from "../../../models/apis/icmetadescription.api";
import { ICMetaDescriptionFilter } from "../../../models/filters/icmetadescription.filter";
import { ICMetaDescriptionService } from "../../../services/icmetadescription.service";
import { ICTranslation } from "../../../models/entities/ictranslation";
import { TranslateService } from "@ngx-translate/core";
import { CustomFilter } from "../../../models/entities/customfilter";
import { ICSchedulationService } from "../../../services/icschedulation.service";
import { ICSchedulationApi } from "../../../models/apis/icschedulation.api";
import { ICAreaType } from "../../../models/entities/icareatype";
import { ICMetaDescription } from "../../../models/entities/icmetadescription";
import { ICArea } from "../../../models/entities/icarea";

@Component({
  selector: "app-area-selector",
  templateUrl: "area-selector.component.html",
  styleUrls: ["area-selector.component.css"],
  providers: [ICMetaDescriptionService],
})
export class AreaSelectorComponent implements OnInit, OnDestroy, OnChanges {
  constructor(
    private schedulationSrv: ICSchedulationService,
    private userSrv: ICUserService,
    private translateSrv: TranslateService,
    private metaDescriptionSrv: ICMetaDescriptionService,
    private areaSrv: ICAreaService,
    private router: Router,
    public zone: NgZone,
  ) {
    this.userSrv.current().then((u) => {
      if (u) {
        this.User = new ICUserApi(u);
      } else {
        this.router.navigateByUrl("/");
      }
    });
  }

  @ViewChild("InputFilter", { static: false }) InputFilter;
  @ViewChild("myModal", { static: false }) modal: ElementRef;

  @Input() MaxLevel: number;
  @Input() SaveFilter: boolean;
  @Input() Locked: boolean;
  @Input() LoadAll: boolean;

  User: ICUserApi;
  SelectedAreas: _.Dictionary<ICAreaApi[]> = {};
  SelectedLevel: number;
  NextAreas: ICAreaApi[] = [];
  SelectedAreaIds: number[] = [];
  ShowSelect = false;
  IgnoreEvents = false;
  Loading = false;
  CurrentAreas: ICAreaApi[];
  CustomFields: ICMetaDescriptionApi[] = [];

  areaSubscription: Subscription;
  schedulationSubscription: Subscription;
  CustomFilter: CustomFilter[] = [];
  currentSchedulations: ICSchedulationApi[];

  ngOnInit(): void {
    this.areaSrv.currents().then((areas: ICAreaApi[]) => {
      if (areas && areas.length > 0) {
        if (areas[0].Level >= 2) {
          this.ShowSelect = true;
        }
      }
      this.initLogic(areas);
    });
    this.areaSubscription = this.areaSrv.CurrentsChanged$.subscribe(
      (areas: ICAreaApi[]) => {
        if (this.IgnoreEvents) return;
        this.initLogic(areas);
      },
    );

    this.schedulationSubscription =
      this.schedulationSrv.CurrentsChanged$.subscribe(
        async (schedulations: ICSchedulationApi[]) => {
          if (this.IgnoreEvents) return;
          if (schedulations) {
            this.currentSchedulations = schedulations;
            this.CustomFilter.length = 0;
            if (schedulations.length > 0) {
              var lArea = (
                await this.areaSrv.get(schedulations[0].AreaApi.Id, false)
              ).ObjectResult;
              const promises = [];
              this.SelectedAreas = null;
              lArea.AllFatherIds.forEach((a) =>
                promises.push(this.areaSrv.get(a, false)),
              );
              var areas = await Promise.all(promises);
              var tmpArea = [
                lArea,
                ...areas
                  .map((t) => t.ObjectResult)
                  .filter((t) => t.Level != lArea.Level),
              ];
              this.NextAreas = [];
              this.initLogic(tmpArea);
            }
          } else {
            this.currentSchedulations = [];
          }
        },
      );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["MaxLevel"]) {
      this.areaSrv.current().then((area: ICAreaApi) => {
        if (area) {
          if (this.MaxLevel == null || this.MaxLevel >= area.Level) {
            this.loadAreas();
          } else {
            let areasToStore: ICAreaApi[] = [];
            if (
              this.SelectedAreas &&
              this.SelectedAreas[this.MaxLevel] &&
              this.SelectedAreas[this.MaxLevel].length > 0
            ) {
              areasToStore = Object.assign(
                [],
                this.SelectedAreas[this.MaxLevel],
              );
            } else {
              const pArea = new ICAreaApi(area).getParent(this.MaxLevel);
              if (pArea && pArea.Id) {
                areasToStore = [pArea];
              }
            }

            if (areasToStore.length > 0) {
              areasToStore.forEach((aToStore) => {
                let currentFix = aToStore;
                let expectedLevel = this.MaxLevel - 1;
                while (expectedLevel >= 0) {
                  if (
                    !currentFix.Fathers ||
                    currentFix.Fathers.length === 0 ||
                    !currentFix.Fathers[0].Father
                  ) {
                    if (
                      this.SelectedAreas &&
                      this.SelectedAreas[expectedLevel] &&
                      this.SelectedAreas[expectedLevel].length > 0
                    ) {
                      currentFix.Fathers = [
                        new ICAreaRelation({
                          Father: this.SelectedAreas[expectedLevel][0],
                        }),
                      ];
                    }
                  }
                  if (
                    currentFix.Fathers &&
                    currentFix.Fathers.length > 0 &&
                    currentFix.Fathers[0].Father
                  ) {
                    currentFix = currentFix.Fathers[0].Father as ICAreaApi;
                  } else {
                    break;
                  }
                  expectedLevel--;
                }
              });

              Object.keys(this.SelectedAreas).forEach((k: string) => {
                if (parseInt(k, 10) > this.MaxLevel) {
                  delete this.SelectedAreas[k];
                }
              });

              if (areasToStore.length === 1) {
                this.areaSrv.store(areasToStore[0]);
              } else {
                this.areaSrv.storeMany(areasToStore);
              }
              this.loadAreas();
            }
          }
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.areaSubscription != null) {
      this.areaSubscription.unsubscribe();
    }
    if (this.schedulationSubscription != null) {
      this.schedulationSubscription.unsubscribe();
    }
  }

  initLogic(areas: ICAreaApi[]) {
    const tmpArea: ICAreaApi[] = [];
    if (areas && areas.length > 0) {
      areas.forEach((cArea) => {
        if (cArea) {
          tmpArea.push(cArea);
          while (
            cArea.Fathers &&
            cArea.Fathers.length > 0 &&
            cArea.Fathers[0].Father &&
            cArea.Fathers[0].Father.Id
          ) {
            cArea = new ICAreaApi(cArea.Fathers[0].Father);
            tmpArea.push(cArea);
          }
        }
      });
    }

    this.SelectedAreas = _.groupBy(
      tmpArea.sort((a, b) => a.Id - b.Id),
      (r: ICAreaApi) => r.Level,
    );
    this.fixSelected();

    if (!areas || areas.length == 0) {
      this.loadAreas();
    }
  }

  async onOldAreaSelected(key: string) {
    this.IgnoreEvents = true;
    await this.schedulationSrv.remove();
    await this.areaSrv.abort("list");
    this.SelectedLevel = parseInt(key, 10);
    Object.keys(this.SelectedAreas).forEach((k: string) => {
      if (parseInt(k, 10) >= this.SelectedLevel) {
        delete this.SelectedAreas[k];
      }
    });
    this.areaSrv.storeLevel(this.SelectedLevel);
    var areas = this.SelectedAreas[this.SelectedLevel - 1] || [];
    areas.forEach((a) => (a.Childrens = []));
    this.areaSrv.storeMany(areas);
    this.IgnoreEvents = false;
    // if (this.SelectedLevel > 0) {
    this.loadAreas();
    //}
  }

  select(): boolean {
    this.ShowSelect = this.theType() >= 2;
    return !this.ShowSelect;
  }

  theType(): number {
    if (this.NextAreas && this.NextAreas.length > 0) {
      const maxLevel = Math.max(...this.NextAreas.map((t) => t.Level));
      console.log(
        `[AreaSelectorComponent] theType: Calculated maxLevel=${maxLevel} from NextAreas (length: ${this.NextAreas.length})`,
      );
      this.areaSrv.storeLevel(maxLevel);
      return maxLevel;
    } else {
      console.log(
        `[AreaSelectorComponent] theType: NextAreas is empty, returning 0`,
      );
      return 0;
    }
  }

  getType(): string {
    switch (this.theType()) {
      case 0:
        return "il Partner";
      case 1:
        return "il Cliente";
      case 2:
        return "la Location";
      case 3:
        return "l'Area";
      default:
        return "";
    }
  }

  onAreaSelectedByModal() {
    if (window.filterResult.length > 0) {
      this.SelectedAreaIds = window.filterResult;
    }

    let selectedAreas = [];
    if (this.SelectedAreaIds.length > 0) {
      selectedAreas = this.NextAreas.filter(
        (t) => this.SelectedAreaIds.indexOf(t.Id) > -1,
      );
      if (selectedAreas.length != this.SelectedAreaIds.length) {
        const promises = [];
        this.SelectedAreaIds.forEach((area) => {
          promises.push(
            new Promise((resolve, reject) => {
              this.areaSrv.get(area).then((r) => {
                return resolve(r.ObjectResult);
              });
            }),
          );
        });
        promises.push();
        Promise.all(promises).then((r) => {
          this.areaSelectedByModal(r);
        });
      } else {
        this.areaSelectedByModal(selectedAreas);
      }
    } else if (this.CustomFilter && this.CustomFilter.length > 0) {
      let tmp = [];
      this.NextAreas.forEach((area) => {
        let pass = false;
        this.CustomFilter.forEach((filter) => {
          if (filter.Id == -1) {
            pass = area.TypeId.toString() === filter.Value.toString();
          } else {
            const filtered = filter.Values.filter((t) => t.Id == filter.Value);
            if (filtered && filtered.length > 0) {
              const valueToCheck = filtered[0].Value.toString();
              pass =
                area.MetaApis.filter(
                  (t) =>
                    t.Value + "" === valueToCheck &&
                    t.MetaDescriptionApi.Id == filter.Id,
                ).length > 0;
            }
          }
        });
        if (pass) {
          tmp.push(area);
        }
      });
      selectedAreas = tmp;
      this.areaSelectedByModal(selectedAreas);
    }
  }

  showModal() {
    this.modal.nativeElement.style =
      "display:block;background: #00000061;overflow-y:auto";
  }

  hideModal($event: MouseEvent) {
    if (
      $event == null ||
      ($event.target as HTMLElement).classList.contains("modal")
    ) {
      this.modal.nativeElement.style = "display:none";
    }
  }

  async checkSchedulation() {
    if (this.CustomFilter.length == 0 && this.currentSchedulations) {
      const aSchedulations = this.currentSchedulations.filter((t) => t.AreaApi);
      const cfSchedulations = this.currentSchedulations.filter(
        (t) => t.MetaDescriptionApi || t.AreaTypeApi,
      );
      if (cfSchedulations && cfSchedulations.length > 0) {
        cfSchedulations.forEach((sched) => {
          const id = sched.AreaTypeApi ? -1 : sched.MetaDescriptionApi.Id;
          const value = sched.AreaTypeApi
            ? sched.AreaTypeApi.Id.toString()
            : sched.MetaValue;
          this.onCustomSelected(
            id,
            isNaN(parseInt(value)) ? value : parseInt(value),
            false,
          );
        });
      } else {
        this.CustomFilter = [];
        if (aSchedulations && aSchedulations.length > 0) {
          this.SelectedAreaIds = aSchedulations.map((t) => t.AreaApi.Id);
        }
      }
      this.updateFilter();
    }
  }

  areaSelectedByModal(selectedAreas) {
    if (selectedAreas == null || selectedAreas.length == 0) {
      return;
    }
    const level = selectedAreas[0].Level || this.theType();
    this.areaSrv.current().then((r) => {
      selectedAreas.forEach((selected) => {
        selected.Fathers = selected.Fathers || [];
        selected.Fathers.push(new ICAreaRelation({ Father: r }));
        selected.Childrens = [];
      });
      const tmpSelectedAreas = this.SelectedAreas;
      this.areaSrv.storeMany(selectedAreas);
      this.SelectedAreas = tmpSelectedAreas;

      // Fix for mixed levels: Group selected areas by level
      const groupedByLevel = _.groupBy(
        selectedAreas,
        (area: ICAreaApi) => area.Level,
      );
      Object.keys(groupedByLevel).forEach((lvl) => {
        this.SelectedAreas[lvl] = groupedByLevel[lvl];
      });

      this.fixSelected();
      this.loadAreas();
    });
  }

  fixSelected() {
    Object.keys(this.SelectedAreas).forEach((key) => {
      const cAreas = this.SelectedAreas[key];
      this.SelectedAreas[key] = [];
      cAreas.forEach((selected) => {
        if (
          this.SelectedAreas[key].filter((t) => t.Id == selected.Id).length == 0
        ) {
          this.SelectedAreas[key].push(selected);
        }
      });
    });
  }

  onAreaSelected(id: number) {
    const selected = this.NextAreas.filter((t) => t.Id == id)[0];
    const level = selected.Level;
    this.areaSrv.current().then((r) => {
      selected.Fathers = selected.Fathers || [];
      if (r) {
        selected.Fathers.push(new ICAreaRelation({ Father: r }));
      }
      this.areaSrv.store(selected);
      if (
        this.SelectedAreas[level] &&
        this.SelectedAreas[level].filter((t) => t.Id == selected.Id).length == 0
      ) {
        this.SelectedAreas[level].push(selected);
      } else if (!this.SelectedAreas[level]) {
        this.SelectedAreas[level] = [selected];
      }
      this.loadAreas();
    });
  }

  deleteFilter(index: number) {
    this.CustomFilter.splice(index, 1);
    this.updateFilter();
  }

  onCustomSelected(id: number, itemValue: string | number = -1, update = true) {
    if (id == -1) {
      this.translateSrv.get("AREA_SELECTOR_TYPE").subscribe((value) => {
        const customFilter = new CustomFilter({
          Id: -1,
          Name: [new ICTranslation({ Value: value })],
          Value: itemValue,
          Values: [],
        });
        this.NextAreas.forEach((element) => {
          if (
            customFilter.Values.filter((t) => t.Id == element.TypeId).length ==
            0
          ) {
            customFilter.Values.push({
              Id: element.TypeId,
              Value: element.Type[0].Value,
            });
          }
        });
        this.CustomFilter.push(customFilter);
      });
    } else {
      const item = this.CustomFields.filter((t) => t.Id == id)[0];
      const customFilter = new CustomFilter({
        Id: item.Id,
        Name: item.Name,
        Value: itemValue,
        Values: [],
      });
      this.NextAreas.forEach((element) => {
        element.MetaApis.filter(
          (t) => t.MetaDescriptionApi.Id == item.Id,
        ).forEach((meta) => {
          const value = {
            Id: meta.Id,
            Value: meta.Value,
          };
          if (
            meta.Value &&
            customFilter.Values.filter((t) => t.Value == value.Value).length ==
              0
          ) {
            customFilter.Values.push(value);
          }
        });
      });
      var valueId = customFilter.Values.filter((f) => f.Value == itemValue);
      if (valueId && valueId.length > 0) {
        customFilter.Value = valueId[0].Id;
      }
      this.CustomFilter.push(customFilter);
    }
    if (update) {
      this.InputFilter.nativeElement.value = "";
      this.updateFilter();
    }
  }

  saveFilter() {
    this.schedulationSrv.remove();
    const filterArray: ICSchedulationApi[] = [];
    if (this.CustomFilter && this.CustomFilter.length > 0) {
      this.CustomFilter.forEach((element) => {
        const areaType =
          element.Id == -1
            ? new ICAreaType({
                Id: parseInt(element.Value.toString()),
                Name: [
                  new Translation({
                    Value: element.Values.filter(
                      (t) => t.Id.toString() === element.Value.toString(),
                    )[0].Value,
                  }),
                ],
              })
            : null;
        const metaValue =
          element.Id != -1
            ? element.Values.filter(
                (t) => t.Id.toString() === element.Value.toString(),
              )[0].Value
            : null;
        const metaDescription =
          element.Id != -1
            ? new ICMetaDescription({ Id: element.Id, Name: element.Name })
            : null;
        const filter = new ICSchedulationApi({
          AreaType: areaType,
          AreaTypeApi: areaType as any,
          MetaValue: metaValue,
          MetaDescription: metaDescription,
          MetaDescriptionApi: metaDescription as any,
        });
        filterArray.push(filter);
      });
      this.schedulationSrv.storeMany(filterArray);
    } else {
      const promises = [];
      this.SelectedAreaIds.forEach((element) => {
        this.areaSrv.get(element, false).then((area) => {
          const filter = new ICSchedulationApi({
            Area: new ICArea({ Id: element, Name: area.ObjectResult.Name }),
          });
          filterArray.push(filter);
        });
      });
      Promise.all(promises).then((r) => {
        this.schedulationSrv.storeMany(filterArray);
      });
    }
  }

  updateFilter() {
    this.zone.run(() => {
      this.CustomFilter = Object.assign([], this.CustomFilter);
      this.SelectedAreaIds = Object.assign([], this.SelectedAreaIds);
      var tmp = Object.assign([], this.CurrentAreas);
      this.CurrentAreas = [];
      setTimeout(() => {
        this.CurrentAreas = Object.assign([], tmp);
      }, 200);
    });
  }

  loadAreas() {
    // Refresh
    this.CustomFilter = [];
    window.filterResult = [];
    this.SelectedAreas = Object.assign({}, this.SelectedAreas);
    this.SelectedAreaIds = [];

    // set Current
    let key = 0;
    Object.keys(this.SelectedAreas).forEach((k) => {
      if (parseInt(k, 10) > key) {
        key = parseInt(k, 10);
      }
    });

    this.CurrentAreas = this.SelectedAreas[key] || [];

    // load Next
    this.NextAreas = [];
    this.areaSrv.current().then((area: ICAreaApi) => {
      if (
        (this.MaxLevel && area && area.Level < this.MaxLevel) ||
        !area ||
        this.MaxLevel == null
      ) {
        if (this.User != null) {
          const filter = new ICAreaFilter({ UserId: this.User.Id });
          this.areaSrv.currents().then((areas) => {
            if (!areas || areas.length == 0) {
              filter.Level = 0;
              this.loadCore(filter);
            } else {
              areas.forEach((r) => {
                const f = new ICAreaFilter({
                  UserId: this.User.Id,
                  AreaIds: [r.Id],
                });
                this.loadCore(f);
              });
            }
          });
        } else {
          this.userSrv.current().then((r: ICUserApi) => {
            this.User = r;
            this.loadAreas();
          });
        }
      }
    });
  }

  loadCore(filter: ICAreaFilter) {
    this.Loading = true;
    this.areaSrv.list(filter, false).then((sAreas) => {
      this.Loading = false;
      if (sAreas && sAreas.ListResult && sAreas.ListResult.length > 0) {
        if (
          filter.Level == null &&
          (!this.CurrentAreas || this.CurrentAreas.length == 0)
        ) {
          const level = Math.min(...sAreas.ListResult.map((t) => t.Level));
          sAreas.ListResult = sAreas.ListResult.filter((t) => t.Level == level);
          this.NextAreas.push(...sAreas.ListResult);
          this.onAreaSelected(this.NextAreas[0].Id);
        } else {
          this.NextAreas = [];
          this.NextAreas.push(...sAreas.ListResult);
          const level = this.theType();
          if (level > 1) {
            this.metaDescriptionSrv
              .list(
                new ICMetaDescriptionFilter({
                  AreaIds: filter.AreaIds,
                  Levels: [level],
                }),
                false,
              )
              .then((meta) => {
                if (meta && meta.Success) {
                  this.CustomFields = meta.ListResult;
                }
              });
          }
        }
        if (!this.CurrentAreas || this.CurrentAreas.length == 0) {
          this.CurrentAreas = this.NextAreas;
          if (
            this.CurrentAreas.length == 1 &&
            !filter.AreaIds &&
            filter.Level == 0
          ) {
            this.onAreaSelected(this.CurrentAreas[0].Id);
          }
        }
      } else if (filter.Level != null) {
        this.loadCore(new ICAreaFilter({ UserId: filter.UserId }));
      }
    });
  }

  getMaxLevel(area: ICAreaApi) {
    if (!area || !area.Level) {
      return null;
    }
    if (area.Level == 2) {
      return area.Level + 2;
    } else {
      return area.Level + 1;
    }
  }
}
